import script from "./SmithDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SmithDialog.vue?vue&type=script&setup=true&lang=js"

import "./SmithDialog.vue?vue&type=style&index=0&id=49afaea3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49afaea3"]])

export default __exports__